import ERC20ABI from "../../utils/abis/ERC20.json";
import SECURITYABI from "../../utils/abis/Security.json";
import { errorToast, successToast } from "../../utils/constants";
import { ChainConfig } from "../../utils/config";
import { ethers } from "ethers";
import { ERC20 } from "@verified-network/verified-sdk";
import { createMeeClient } from "@biconomy/abstractjs";
import PaymentProcess from "../../components/popups/paymentProcess";
import SuccessPopup from "../../components/popups/success";
import { handleCustodyTransaction } from "../../utils/helpers/hextrust";

export const castVote = async (
  chainId,
  userAddress,
  web3,
  securityAddress,
  resolutionDate,
  voteType,
) => {
  try {
    if (web3) {
      const securityContract = new web3.eth.Contract(
        SECURITYABI,
        securityAddress,
      );
      return await securityContract.methods
        .vote(resolutionDate, voteType)
        .send({ from: userAddress })
        .then((res) => {
          successToast(
            "Transaction Successful!",
            "Vote Cast Successfully",
            `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.transactionHash}`,
          );
          return true;
        })
        .catch((err) => {
          errorToast("Oops Something went wrong", "Cast Vote Failed");

          console.error("Transaction Failed: ", err);
          return false;
        });
    }
  } catch (err) {
    errorToast("Oops Something went wrong", "Cast Vote Failed");
    console.error("Transaction err: ", err);
    return false;
  }
};

export const sendFunds = async (
  chainId,
  provider,
  signer,
  tokenAddress,
  senderAddress,
  receiverAddress,
  amountInWei,
  amountInEther,
  paymentToken,
  web3,
  custodyWalletDetails,
  verifiedWalletDetails,
  nexusAccount,
  helpers,
) => {
  if (
    custodyWalletDetails &&
    Object.keys(custodyWalletDetails)?.length > 0 &&
    custodyWalletDetails?.custodyId?.length > 0 &&
    custodyWalletDetails?.address &&
    custodyWalletDetails?.chainId > 0 &&
    web3 &&
    provider &&
    tokenAddress &&
    senderAddress &&
    receiverAddress &&
    amountInWei
  ) {
    if (
      tokenAddress?.toLowerCase() !== ethers.constants.AddressZero.toLowerCase()
    ) {
      const tokenContract = new web3.eth.Contract(ERC20ABI, tokenAddress);
      const txData = tokenContract.methods
        .transfer(receiverAddress, Number(amountInWei))
        .encodeABI();
      const txNonce = await web3.eth.getTransactionCount(
        custodyWalletDetails?.address,
      );
      return await handleCustodyTransaction(
        custodyWalletDetails,
        tokenAddress,
        provider,
        "0",
        txData,
        web3.utils.toHex(txNonce),
        "Verified-Network-transfer",
      ).then((cusRes) => {
        if (cusRes?.toLowerCase() === "completed") {
          successToast("Transaction Successful!", "Sent Funds Successfully");
          return true;
        } else {
          errorToast(
            "Opps something went wrong",
            "Send Funds failed. Try again later",
          );

          return false;
        }
      });
    } else if (
      tokenAddress?.toLowerCase() === ethers.constants.AddressZero.toLowerCase()
    ) {
      const txNonce = await web3.eth.getTransactionCount(
        custodyWalletDetails?.address,
      );
      return await handleCustodyTransaction(
        custodyWalletDetails,
        receiverAddress,
        provider,
        amountInEther?.toString(),
        null,
        web3.utils.toHex(txNonce),
        "Verified-Network-Send-Funds",
      ).then((cusRes) => {
        if (cusRes?.toLowerCase() === "completed") {
          successToast("Transaction Successful!", "Sent funds successfully");
          return true;
        } else {
          errorToast("Oops Something went wrong", "Send funds failed");

          return false;
        }
      });
    } else {
      errorToast("Oops Something went wrong", "Unexpected error occured");
      return false;
    }
  } else {
    if (
      chainId &&
      provider &&
      signer &&
      tokenAddress &&
      senderAddress &&
      receiverAddress &&
      amountInWei
    ) {
      helpers?.setCustomPopupPosition?.("flex-end");
      helpers?.setCustomPopupContent?.(
        <PaymentProcess
          title={"Sending Funds"}
          description={"Sending token from your account to recipient's account"}
        />,
      );

      helpers?.setShowCustomPopup?.(true);
      const tokenContract = new ERC20(signer, tokenAddress);

      if (
        tokenAddress?.toLowerCase() !==
        ethers.constants.AddressZero.toLowerCase()
      ) {
        return await tokenContract
          ?.transfer(
            receiverAddress,
            amountInWei,
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                  rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                }
              : {},
          )
          .then((res) => {
            if (res?.status === 0) {
              successToast(
                "Transaction Successful!",
                "Sent Funds Successfully",
                `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
              );
              return true;
            } else {
              helpers?.setCustomPopupPosition?.("flex-end");
              helpers?.setCustomPopupContent?.(
                <SuccessPopup
                  setShowPopup={helpers?.setShowPopup}
                  setPopupContent={helpers?.setPopupContent}
                  setPopupContentPosition={helpers?.setPopupContentPosition}
                  isCustom={true}
                  customTextHeader="Transaction Failed!"
                  customTextFooter="Send funds failed."
                  setFavouriteClicked={helpers?.setFavouriteClicked}
                  isError={true}
                  setCustomPopupPosition={helpers?.setCustomPopupPosition}
                  setCustomPopupContent={helpers?.setCustomPopupContent}
                  setShowCustomPopup={helpers?.setShowCustomPopup}
                />,
              );
              helpers?.setShowCustomPopup?.(true);

              errorToast("Transaction Failed", "Send funds Failed");
              return false;
            }
          })
          .catch((err) => {
            helpers?.setCustomPopupPosition?.("flex-end");
            helpers?.setCustomPopupContent?.(
              <SuccessPopup
                setShowPopup={helpers?.setShowPopup}
                setPopupContent={helpers?.setPopupContent}
                setPopupContentPosition={helpers?.setPopupContentPosition}
                isCustom={true}
                customTextHeader="Transaction Failed!"
                customTextFooter="Something went wrong"
                setFavouriteClicked={helpers?.setFavouriteClicked}
                isError={true}
                setCustomPopupPosition={helpers?.setCustomPopupPosition}
                setCustomPopupContent={helpers?.setCustomPopupContent}
                setShowCustomPopup={helpers?.setShowCustomPopup}
              />,
            );
            helpers?.setShowCustomPopup?.(true);
            errorToast("Oops Something went wrong", "Send funds failed");

            console.error("Transaction Failed: ", err);
            return false;
          });
      } else if (
        tokenAddress?.toLowerCase() ===
        ethers.constants.AddressZero.toLowerCase()
      ) {
        if (
          verifiedWalletDetails &&
          Object?.keys(verifiedWalletDetails)?.length > 0 &&
          nexusAccount
        ) {
          try {
            const meeClient = await createMeeClient({
              account: nexusAccount,
              apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
            });

            const transactionInstruction = await nexusAccount.build({
              type: "default",
              data: {
                chainId,
                calls: [
                  {
                    chainId: chainId,
                    to: receiverAddress,
                    value: amountInWei,
                    data: "0x",
                  },
                ],
              },
            });

            const nowInSec = Math.floor(Date.now() / 1000);

            const { hash } = await meeClient.execute({
              feeToken: {
                chainId,
                address: paymentToken?.address,
              },
              instructions: [transactionInstruction],

              upperBoundTimestamp: nowInSec + 299, //highest is 5 minutes???
            });

            const receipt = await meeClient.waitForSupertransactionReceipt({
              hash,
            });

            if (receipt?.receipts?.length > 1) {
              //at least 2 receipts
              const txReceipt =
                receipt?.receipts[receipt?.receipts?.length - 1];
              if (txReceipt?.status === "success") {
                successToast(
                  "Transaction Successful!",
                  "Sent funds successfully",
                  `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${txReceipt?.transactionHash}`,
                );
                return true;
              } else {
                helpers?.setCustomPopupPosition?.("flex-end");
                helpers?.setCustomPopupContent?.(
                  <SuccessPopup
                    setShowPopup={helpers?.setShowPopup}
                    setPopupContent={helpers?.setPopupContent}
                    setPopupContentPosition={helpers?.setPopupContentPosition}
                    isCustom={true}
                    customTextHeader="Transaction Failed!"
                    customTextFooter="Send funds failed"
                    setFavouriteClicked={helpers?.setFavouriteClicked}
                    isError={true}
                    setCustomPopupPosition={helpers?.setCustomPopupPosition}
                    setCustomPopupContent={helpers?.setCustomPopupContent}
                    setShowCustomPopup={helpers?.setShowCustomPopup}
                  />,
                );
                helpers?.setShowCustomPopup?.(true);
                errorToast("Transaction failed", "Send funds failed");

                return false;
              }
            } else {
              console.error(
                "MEE client transaction failed with error: ",
                "Receipts lesser than one.",
              );
              helpers?.setCustomPopupPosition?.("flex-end");
              helpers?.setCustomPopupContent?.(
                <SuccessPopup
                  setShowPopup={helpers?.setShowPopup}
                  setPopupContent={helpers?.setPopupContent}
                  setPopupContentPosition={helpers?.setPopupContentPosition}
                  isCustom={true}
                  customTextHeader="Transaction Failed!"
                  customTextFooter="Something went wrong"
                  setFavouriteClicked={helpers?.setFavouriteClicked}
                  isError={true}
                  setCustomPopupPosition={helpers?.setCustomPopupPosition}
                  setCustomPopupContent={helpers?.setCustomPopupContent}
                  setShowCustomPopup={helpers?.setShowCustomPopup}
                />,
              );
              helpers?.setShowCustomPopup?.(true);
              errorToast("Oops Something went wrong", "Send funds failed");

              return false;
            }
          } catch (err) {
            helpers?.setCustomPopupPosition?.("flex-end");
            helpers?.setCustomPopupContent?.(
              <SuccessPopup
                setShowPopup={helpers?.setShowPopup}
                setPopupContent={helpers?.setPopupContent}
                setPopupContentPosition={helpers?.setPopupContentPosition}
                isCustom={true}
                customTextHeader="Transaction Failed!"
                customTextFooter="Something went wrong"
                setFavouriteClicked={helpers?.setFavouriteClicked}
                isError={true}
                setCustomPopupPosition={helpers?.setCustomPopupPosition}
                setCustomPopupContent={helpers?.setCustomPopupContent}
                setShowCustomPopup={helpers?.setShowCustomPopup}
              />,
            );
            helpers?.setShowCustomPopup?.(true);
            errorToast("Oops Something went wrong", "Send funds failed");

            return false;
          }
        } else {
          const transactionObject = {
            from: senderAddress,
            to: receiverAddress,
            value: amountInWei,
          };
          try {
            const transaction = await provider
              .getSigner(senderAddress)
              .sendTransaction(transactionObject);
            let pendingTransaction = await transaction.wait();
            if (pendingTransaction?.transactionHash) {
              successToast(
                "Transaction Successful!",
                "Sent funds successfully",
                `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${pendingTransaction?.transactionHash}`,
              );
              return true;
            } else {
              helpers?.setCustomPopupPosition?.("flex-end");
              helpers?.setCustomPopupContent?.(
                <SuccessPopup
                  setShowPopup={helpers?.setShowPopup}
                  setPopupContent={helpers?.setPopupContent}
                  setPopupContentPosition={helpers?.setPopupContentPosition}
                  isCustom={true}
                  customTextHeader="Transaction Failed!"
                  customTextFooter="Send funds failed."
                  setFavouriteClicked={helpers?.setFavouriteClicked}
                  isError={true}
                  setCustomPopupPosition={helpers?.setCustomPopupPosition}
                  setCustomPopupContent={helpers?.setCustomPopupContent}
                  setShowCustomPopup={helpers?.setShowCustomPopup}
                />,
              );
              helpers?.setShowCustomPopup?.(true);
              errorToast("Transaction Failed", "Send funds failed");
              return false;
            }
          } catch (err) {
            helpers?.setCustomPopupPosition?.("flex-end");
            helpers?.setCustomPopupContent?.(
              <SuccessPopup
                setShowPopup={helpers?.setShowPopup}
                setPopupContent={helpers?.setPopupContent}
                setPopupContentPosition={helpers?.setPopupContentPosition}
                isCustom={true}
                customTextHeader="Transaction Failed!"
                customTextFooter="Something went wrong"
                setFavouriteClicked={helpers?.setFavouriteClicked}
                isError={true}
                setCustomPopupPosition={helpers?.setCustomPopupPosition}
                setCustomPopupContent={helpers?.setCustomPopupContent}
                setShowCustomPopup={helpers?.setShowCustomPopup}
              />,
            );
            helpers?.setShowCustomPopup?.(true);
            errorToast("Oops Something went wrong", "Send funds failed");

            return false;
          }
        }
      } else {
        helpers?.setCustomPopupPosition?.("center");
        helpers?.setCustomPopupContent?.(null);
        helpers?.setShowCustomPopup?.(false);
        errorToast("Oops Something went wrong", "Unexpected error occured");
        return false;
      }
    }
  }
};
